import { getTimeZoneData, isNullOrUndefined } from '@bimser/core';
import * as React from 'react';
import BCCombobox, { IComboboxSelectedChangeEventArgs } from '../../../BCCombobox';
import { IPropertyComponentProps, IPropertyItem, ISelectPropertyProps } from '../../entities';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
const inputStyle: React.CSSProperties = { width: '100%' };

dayjs.extend(utc);
dayjs.extend(timezone);

const timeZones = getTimeZoneData();
const localArea = timeZones.filter(
	t => t.displayName.indexOf(dayjs().tz(dayjs.tz.guess()).format('z')) != -1
);
const keyWords = dayjs.tz.guess().split('/').reverse();
const localTimeZone = keyWords
	.map((t: string) =>
		localArea.find(c => c.displayName.indexOf(t) != -1 || c.id.indexOf(t) != -1)
	)
	.filter((t: any) => !isNullOrUndefined(t));
const localTimeZoneItem = localTimeZone[0] ?? localArea[0] ?? { id: null, displayName: null };

const timeZoneOptions: Array<any> = [
	{
		key: localTimeZoneItem.id,
		text: `Local (${localTimeZoneItem.displayName})`,
		value: localTimeZoneItem.id,
		externalData: {}
	},
	...timeZones
		.map(data => ({ key: data.id, text: data.displayName, value: data.id }))
		.filter(x => x.key != localTimeZoneItem.id)
].filter(x => x != undefined);

export default function TimeZoneProperty(props: IPropertyComponentProps & ISelectPropertyProps) {
	const replaceValue = (item: IPropertyItem, newValue: any) => {
		props.onValueChanged(item, newValue);
	};

	const onSelectedChange = (e: IComboboxSelectedChangeEventArgs) => {
		props.customChangeEvent
			? props.customChangeEvent(e.data)
			: replaceValue(props.item, e.data);
	};

	const allowClear =
		props.item.externalData?.allowClear !== undefined
			? props.item.externalData.allowClear
			: true;

	return (
		<BCCombobox
			onSelectedChange={onSelectedChange}
			options={timeZoneOptions}
			showSearch
			style={props.style || inputStyle}
			disabled={props.item.disabled || props.item.readOnly || props.readonly}
			allowClear={allowClear}
			value={props.value}
			dropdownStyle={props.dropdownStyle}
			size="small"
		/>
	);
}
